/* Pawdoh shipping bar. Load once, globally from theme.liquid. */
(() => {
  if (customElements.get('pawdoh-shipping-bar')) return;

  const money = (subunits, currency) => {
    // Shopify cart money values use 100-unit precision, even for JPY/KRW.
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency,maximumFractionDigits:2}).format(subunits / 100); }
    catch (_) { return (subunits/100).toFixed(2) + ' ' + currency; }
  };

  class PawdohShippingBar extends HTMLElement {
    connectedCallback() {
      this.update(Number(this.dataset.cartTotal || 0));
      this.refresh();
    }
    update(total) {
      const threshold = Number(this.dataset.threshold);
      const text = this.querySelector('.pawdoh-fsb__text');
      const rail = this.querySelector('.pawdoh-fsb__rail');
      const currency = this.dataset.currency || 'USD';
      if (!text || !rail) return;
      if (!Number.isFinite(threshold) || threshold <= 0) {
        text.textContent = 'Free shipping on orders over $100 USD';
        rail.hidden = true;
        return;
      }
      rail.hidden = false;
      const remaining = Math.max(0, threshold - total);
      const pct = Math.max(0, Math.min(100, 100 * total / threshold));
      this.classList.toggle('pawdoh-fsb--goal', remaining <= 0);
      text.textContent = remaining <= 0
        ? 'Yay! Your order qualifies for free shipping! 🐾'
        : `You're ${money(remaining, currency)} away from free shipping! 🐾`;
      this.querySelector('.pawdoh-fsb__fill').style.width = pct + '%';
      this.querySelector('.pawdoh-fsb__cursor').style.left = pct + '%';
      rail.setAttribute('aria-valuenow', String(Math.round(pct)));
    }
    async refresh() {
      if (!this.isConnected) return;
      try {
        const root = window.Shopify?.routes?.root || '/';
        const res = await fetch(root + 'cart.js', {credentials:'same-origin'});
        if (!res.ok) throw new Error('Cart unavailable');
        const cart = await res.json();
        if (this.isConnected) this.update(Number(cart.total_price || 0));
      } catch (error) { /* Keep server-rendered state if network is unavailable. */ }
    }
  }
  customElements.define('pawdoh-shipping-bar', PawdohShippingBar);

  let debounce;
  const refreshAll = () => {
    clearTimeout(debounce);
    debounce = setTimeout(() => document.querySelectorAll('pawdoh-shipping-bar').forEach(el => el.refresh()), 250);
  };
  // Common theme/app custom events; cart drawers that rerender the component
  // automatically reconnect it and trigger a fresh fetch.
  ['cart:updated','cart:refresh','cart:change','cart:rendered','product:added'].forEach(evt => document.addEventListener(evt, refreshAll));
  // Helps with themes where quantity updates do not emit a cart event.
  document.addEventListener('change', e => {
    if (e.target.closest('cart-items, cart-drawer, form[action*="/cart"]')) setTimeout(refreshAll, 450);
  });
  document.addEventListener('click', e => {
    if (e.target.closest('cart-remove-button, .quantity__button, button[name="add"]')) {
      setTimeout(refreshAll, 700);
      setTimeout(refreshAll, 1600);
    }
  });
})();
